import { render, staticRenderFns } from "./transformation-all.vue?vue&type=template&id=15e60416"
import script from "./transformation-all.vue?vue&type=script&lang=js"
export * from "./transformation-all.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports